<template>
  <div>
    <!-- <div class="mb-4">
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="38" viewBox="0 0 40 38" fill="none" style="cursor: pointer;" @click="goBack()">
        <path d="M38.75 19.0003H1.25M1.25 19.0003L18.9583 1.29199M1.25 19.0003L18.9583 36.7087" stroke="#FF7C48" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div> -->

    <!-- <h4>{{ $t("file-manager.pending-approval") }}</h4> -->
    <table style="width: 100%;" class="mt-4">
      <thead>
        <tr>
          <th class="w-5">{{ $t("file-manager.no") }}</th>
          <th class="w-20">{{ $t("file-manager.name") }}</th>
          <th class="w-5">{{ $t("common.version") }}</th>
          <th class="w-10">{{ $t("file-manager.upload-date") }}</th>
          <th class="w-5">{{ $t("file-manager.size") }}</th>
          <th class="w-15">{{ $t("file-manager.uploader") }}</th>
          <th class="w-15">{{ $t("file-manager.admin") }}</th>
          <th class="w-5"></th>
        </tr>
      </thead>
      <tbody v-if="filePagination">
        <tr v-for="file in filePagination.docs" :key="'file-' + file._id" class="hand">
          <td class="gray-text">#{{ file.no }}</td>
          <td>
            <a href="javascript: void(0);" class="text-dark fw-medium"
              ><i class="mdi mdi-file-document font-size-16 align-middle text-primary me-2"></i> {{ file.name | translate | summary }}</a
            >
          </td>

          <td>{{ file.version }}</td>
          <td>{{ file.updatedAt | date }}</td>
          <td>{{ file.size | formatByte }}</td>
          <td>
            <span v-if="file.uploader">{{ file.uploader.name }}</span>
          </td>
          <td>
            <span v-if="file.admin">{{ file.admin.name }}</span>
          </td>
          <td>
            <button @click="redirectToSurveys(file)" class="btn btn-success">{{ $t("file-approval-survey.view-plural") }}</button>
          </td>
        </tr>
      </tbody>
    </table>
    <content-loading v-if="isOrganizationFilesLoading" />
    <empty v-if="!filePagination || filePagination.docs.length == 0">
      <h5 class="text-center">
        {{ $t("file-approval-survey.empty") }}
      </h5>
    </empty>

    <div v-if="filePagination" class="row">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="fileRequest.options.page" :total-rows="filePagination.totalDocs" :per-page="filePagination.limit" limit="3" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import FileAccessingMembersForm from "./file-accessing-members-form.vue";
import FileCategoryForm from "./file-category-form.vue";
import FileHistory from "./file-history.vue";
import FileUpload from "./file-upload.vue";
import InventoryDiff from "./inventory-diff.vue";
export default {
  props: ["scope"],
  components: {
    FileCategoryForm,
    FileUpload,
    FileAccessingMembersForm,
    FileHistory,
    InventoryDiff,
  },
  data() {
    return {
      fileRequest: {
        options: { page: 1, limit: 10, sort: {} },
        query: { "approval.path": { value: { $exists: 1 }, isObject: true } },
        // query: { $or: [{ latest: false }, { "approval.path": { $exists: 1 } }] },
      },
    };
  },
  watch: {
    fileRequest: {
      deep: true,
      immdediate: true,
      handler() {
        this.debounce(() => this.fetchFiles());
      },
    },
  },
  computed: {
    filePagination() {
      return this.$store.getters[`fileManager/pendingApprovalPagination`];
    },
    isOrganizationFilesLoading() {
      return this.$store.getters["fileManager/isLoading"];
    },
  },

  mounted() {
    this.fetchFiles();
  },
  methods: {
    goBack() {
      this.$router.push(`/${this.currentProduct ? this.currentProduct.toLowerCase() : "organization"}/file-manager/`);
    },
    redirectToSurveys(file) {
      this.$store.commit("fileManager/selectedEntity", file);
      this.$router.push(`/${this.currentProduct ? this.currentProduct.toLowerCase() : "organization"}/file-approval-survey/${file._id}/survey`);
    },
    async fetchFiles() {
      let request = { ...this.fileRequest };

      request.query = {
        ...request.query,
        ...(this.currentProduct ? { products: { value: this.currentProduct, isObject: true } } : {}),
        admin: { value: this.currentAccount, isObject: true },
      };

      await this.$store.dispatch(`fileManager/pendingApprovalPaginate`, request);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../task/tasks.scss";
</style>
